import request from '@/utils/request'

export function fetchMyTasks(page, params, size = 15) {
  return request({
    url: 'task/listing',
    method: 'post',
    data: {
      ...params,
      page: page,
      size: size
    }
  })
}

export function fetchBorrowerInfo(taskId) {
  return request({
    url: 'task/userInfo/' + taskId,
    method: 'get'
  })
}

export function fetchTaskInfo(taskId) {
  return request({
    url: 'task/info/' + taskId,
    method: 'get'
  })
}

export function fetchLoanItemInfo(taskId) {
  return request({
    url: 'task/loanItemInfo/' + taskId,
    method: 'get'
  })
}

// workLogInfo
export function fetchContactsInfo(taskId) {
  return request({
    url: 'task/userContacts/' + taskId,
    method: 'get'
  })
}

export function fetchUserContactsInfo(taskId) {
  return request({
    url: 'task/userAddressBook/' + taskId,
    method: 'get'
  })
}

export function fetchUserCallsInfo(taskId) {
  return request({
    url: 'task/userCallRecord/' + taskId,
    method: 'get'
  })
}

export function fetchUserAddress(taskId) {
  return request({
    url: 'task/userAddress/' + taskId,
    method: 'get'
  })
}

export function fetchUserSMSRecord(taskId) {
  return request({
    url: 'task/userSMSRecord',
    method: 'post',
    data: {
      taskId
    }
  })
}

export function fetchReportList(taskId, page, size) {
  return request({
    url: 'task/getReportList',
    method: 'post',
    data: {
      page,
      size,
      taskId
    }
  })
}

// CollectionLog
export function fetchCollectionLogs(contractNumber, currentPage, pageSize, userId) {
  return request({
    url: 'task/collectionLogs',
    method: 'post',
    data: {
      currentPage,
      pageSize,
      contractNumber,
      userId
    }
  })
}

// queryMertCaseList
export function queryMertCaseList(contractNumber, currentPage, pageSize) {
  return request({
    url: 'mertCase/queryMertCaseList',
    method: 'post',
    params: {
      currentPage,
      pageSize,
      contractNumber
    }
  })
}

// queryCaseSionList
export function queryCaseSionList(casePkid, contractNumber, currentPage, pageSize) {
  return request({
    url: 'mertCase/queryCaseSionList',
    method: 'post',
    params: {
      currentPage,
      pageSize,
      contractNumber,
      casePkid
    }
  })
}

// CollectionLog
export function getCollectionLog(taskId, page, size) {
  return request({
    url: 'task/getCollectionLog',
    method: 'post',
    data: {
      page,
      size,
      taskId
    }
  })
}

// RepayPlan
export function fetchRepayPlan(params) {
  return request({
    url: 'repay/details',
    method: 'post',
    data: params
  })
}

export function fetchPayLogs(params) {
  return request({
    url: 'repay/payLogs',
    method: 'post',
    data: params
  })
}

export function recordCollectionLog(params) {
  return request({
    url: 'task/record',
    method: 'post',
    data: params
  })
}

export function deduct(params) {
  return request({
    url: 'task/partDeduce',
    method: 'post',
    data: params
  })
}

export function getAllLabel(taskId) {
  return request({
    url: 'task/getAllLabel',
    method: 'get',
    params: {
      taskId
    }
  })
}

export function getTaskCheckList(taskId) {
  return request({
    url: 'task/getTaskCheckList',
    method: 'get',
    params: {
      taskId
    }
  })
}

export function getTaskLabel(taskId) {
  return request({
    url: 'task/getTaskLabel',
    method: 'get',
    params: {
      taskId
    }
  })
}

export function setTaskLabel(data) {
  return request({
    url: 'task/setTaskLabel',
    method: 'post',
    data
  })
}

export function nextArticle(data) {
  return request({
    url: 'task/nextArticle',
    method: 'post',
    data
  })
}

export function setSpecialTask(data) {
  return request({
    url: 'task/setSpecialTask',
    method: 'post',
    data
  })
}

export function getSpecialTaskList(data) {
  return request({
    url: 'task/listing',
    method: 'post',
    data
  })
}

// 加入/移出特殊队列
export function specialQueueOperator(params) {
  return request({
    url: 'task/specialQueueOperator',
    method: 'post',
    params
  })
}

// 分案
export function manualDivisionTasks(params) {
  return request({
    url: 'task/manualDivisionTasks',
    method: 'post',
    params
  })
}

// 更新案件
export function updateLatestBillinfo(params) {
  return request({
    url: 'task/updateLatestBillinfo',
    method: 'post',
    params
  })
}

export function getUserToken(data) {
  return request({
    url: 'task/getUserToken',
    method: 'post',
    data
  })
}

// 队列
export function getWorkQueueList(data) {
  return request({
    url: 'task/getWorkQueueList',
    method: 'get',
    data
  })
}

// 字典
// dictType 字典类型 必填（fd_business_type-业务类型，profuct-产品）
export function getDictionaryList(dictType) {
  return request({
    url: 'task/getDictionaryList',
    method: 'get',
    params: {
      dictType
    }
  })
}
// 除其他联系人外可自动带出“联络人”、“联系电话”及“与借款人关系”
// 根据taskId和联系类型获取联系人信息
export function getContactList(data) {
  return request({
    url: 'task/getContact',
    method: 'get',
    params: data
  })
}
// 除其他联系人外可自动带出“联络人”、“联系电话”及“与借款人关系”
// 根据taskId和联系ID获取联系人信息
export function getContactByTaskIdAndContactId(data) {
  return request({
    url: 'task/getContactByTaskIdAndContactId',
    method: 'get',
    params: data
  })
}

// 影像资料
export function queryMaterialList(data) {
  return request({
    url: 'task/queryMaterialList',
    method: 'get',
    params: data
  })
}
export function queryMaterialListByType(data) {
  return request({
    url: 'task/queryMaterialListByType',
    method: 'get',
    params: data
  })
}
// 查询人脸
export function queryFaceList(data) {
  return request({
    url: 'task/queryFaceList',
    method: 'post',
    params: data
  })
}
// 根据taskId实时获取还款计划
export function queryrepayPlanList(data) {
  return request({
    url: 'repay/plan',
    method: 'get',
    params: data
  })
}
// 根据taskId实时获取还款记录
export function repaymentRecordList(data) {
  return request({
    url: 'repay/getRepaymentRecord',
    method: 'get',
    params: data
  })
}

// 报案原因
export function getCaseRean() {
  return request({
    url: 'mertCase/getCaseRean',
    method: 'post'
  })
}

export function getCaseReanByFatherId(params) {
  return request({
    url: 'mertCase/getCaseReanByFatherId',
    method: 'post',
    params
  })
}

// 报案保存
export function saveMertCase(params) {
  return request({
    url: 'mertCase/saveMertCase',
    method: 'post',
    params
  })
}

export function addOrUpdateContact(data) {
  return request({
    url: 'task/addOrUpdateContact',
    method: 'post',
    data
  })
}

export function getafdOrg() {
  return request({
    url: 'task/getafdOrg',
    method: 'get'
  })
}
